import { MaskedLine, Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, lines, text, children }) => (
  <section className="relative overflow-hidden pb-14 pt-32 sm:pb-20 sm:pt-40">
    <div className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full bg-sage-light/50 blur-3xl" />
    <div className="pointer-events-none absolute -left-24 top-40 h-72 w-72 rounded-full bg-terracotta-soft/40 blur-3xl" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-terracotta sm:text-sm">{eyebrow}</p>
      </Reveal>
      <h1 className="mt-4 max-w-3xl font-serif text-4xl tracking-tight text-forest sm:text-5xl lg:text-6xl lg:leading-[1.08]">
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.12 + i * 0.12}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {text && (
        <Reveal delay={0.45}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-pebble sm:text-lg">{text}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);
